import React from "react";
import gfgteam from "../assets/gfg_team_cropped.jpg";
import "../styles/about.css";

function About() {
  return (
    <>
      <div className="Mabtuscontainer">
        <div className="MaboutUScard flex-row">
          <h1 style={{ paddingTop: "20px" }}>About US</h1>
          <div id="abtpictext">
            <div>
              <img id="gfg_team" src={gfgteam} alt="gfg_team" />
            </div>
            <div>
              <p id="Mabt_content">
                Welcome to{" "}
                <span id="splText">GeeksForGeeks Students Chapter VIIT</span> a
                dynamic community of likeminded students passionate about
                various core technical competencies, where technical skills,
                networking, and soft skills are continuously honed. Through a
                range of events and webinars on coding, industry insights, we
                offer enriching experiences that help you stay ahead of the fast
                paced world of technology. With{" "}
                <span id="splText">GeeksForGeeks VIIT</span> you also get access
                exclusive discounts on courses.
                <br></br>
                <br></br>
                Be a part of <span id="splText">GeeksForGeeks VIIT</span> and
                witness exciting events where you collaborate, share ideas and,
                work together on real-world problem-solving through contests and
                collaborative projects. Join us to grow technically, expand your
                network across 145+ colleges, and thrive in a competitive, yet
                inclusive environment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
